import { Type } from "class-transformer";
import { CoronerModel } from "./coroner.model";
import { DeadPersonModel } from "./deadPerson.model";

export class DeathDetailModel {
  dthId: string;
  @Type(() => Date) dthDateOfDeath: Date;
  dthCauseOfDeath: any;
  dthDescription: string;
  dthIsAutopy: any;
  dthIsPoliceInvolved: any;
  deadPerson: DeadPersonModel = new DeadPersonModel();
  dutchCoroner: CoronerModel = new CoronerModel();
  foreignCorner: CoronerModel = new CoronerModel();
}